module.exports = __webpack_public_path__ + "static/media/cloudy.9d3c104e.png";